import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { Contact } from '../../../contacts/shared/contact.model';
import { MenuItem } from 'primeng/api';
import { ProfileContactsAnalyticsDialogComponent } from '../profile-contacts-analytics-dialog/profile-contacts-analytics-dialog.component';
import { UserService } from 'src/app/users/shared/user.service';
import { TranslationService } from 'src/app/shared/translation/translation.service';

@Component({
  selector: 'wl-profile-contact-card',
  templateUrl: './profile-contact-card.component.html',
  styleUrls: ['./profile-contact-card.component.less'],
    standalone: false
})
export class ProfileContactCardComponent implements OnInit {
  profileContactsTabFullAccess: boolean = false;
  @Input() profileContact: Contact;
  @Output() editClicked: EventEmitter<Contact> = new EventEmitter();
  @Output() deleteClicked: EventEmitter<Contact> = new EventEmitter();
  @ViewChild(ProfileContactsAnalyticsDialogComponent) _profileContactsAnalyticsDialogComponent: ProfileContactsAnalyticsDialogComponent;

  actionItems: MenuItem[];

  menuDoesNotHaveAnyItems: boolean;

  constructor(
    private _translationService: TranslationService,
    private _userService: UserService) {}

  ngOnInit() {
    this._userService.getCurrentUserSecurityElementAccessLevel('ProfileContacts_Tab').then((userAccessLevel: number) => {
      this.profileContactsTabFullAccess = userAccessLevel > 1;
      this.menuDoesNotHaveAnyItems = !this.profileContactsTabFullAccess && this.profileContact.MessageID === 0;
      this.initActionItems();
    });
  }

  viewAnalytics(contact: Contact): void {
    this._profileContactsAnalyticsDialogComponent.open(contact);
  }

  initActionItems() {
    this.actionItems = [
      {
        label: this._translationService.getInstantTitlecase('profiles.contact.view-analytics'),
        visible: this.profileContact.MessageID > 0,
        command: () => this.viewAnalytics(this.profileContact),
      },
      {
        label: this._translationService.getInstantTitlecase('common.edit'),
        visible: this.profileContactsTabFullAccess,
        command: () => this.editClicked.emit(this.profileContact),
      },
      {
        label: this._translationService.getInstantTitlecase('common.delete'),
        visible: this.profileContactsTabFullAccess,
        command: () => this.deleteClicked.emit(this.profileContact),
      },
    ];
  }
}
